<template lang="pug">
.mb-20
  TimeEntriesProjectSelect(
    :value="projectId"
    :project-options="projectOptions"
    :secondary-project-options="secondaryProjectOptions"
    :manual-time-request="manualTimeRequest"
    :extend-time-using-manual-time-request="extendTimeUsingManualTimeRequest"
    :disabled="projectDisabled"
    :required="projectRequired"
    @input="updateProjectId"
  )
  TimeEntriesTaskSelect(
    v-if="taskId || !taskDisabled"
    :value="taskId"
    :project-id="projectId"
    :user-id="userId"
    :initial-options="taskOptions"
    :disabled="taskDisabled"
    :required="taskRequired"
    :manual-time-request="manualTimeRequest"
    :extend-time-using-manual-time-request="extendTimeUsingManualTimeRequest"
    @input="updateTaskId"
  )
</template>

<script>
export default {
  name: 'TimeEntriesProjectTaskSelects',
  props: {
    projectId: {
      default: null,
    },
    taskId: {
      default: null,
    },
    userId: {
      default: null,
    },
    projectDisabled: {
      type: Boolean,
      default: false,
    },
    taskDisabled: {
      type: Boolean,
      default: false,
    },
    taskRequired: {
      type: Boolean,
      default: false,
    },
    projectRequired: {
      type: Boolean,
      default: true,
    },
    projectOptions: {
      type: Array,
      default: () => [],
    },
    secondaryProjectOptions: {
      type: Array,
      default: () => [],
    },
    taskOptions: {
      type: Array,
      default: () => [],
    },
    manualTimeRequest: {
      type: Boolean,
      default: false,
    },
    extendTimeUsingManualTimeRequest: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateProjectId(value) {
      this.$emit('input', [value, null]);
    },
    updateTaskId(value) {
      this.$emit('input', [this.projectId, value]);
    },
  },
};
</script>
